export const ASSETS = {
  logo: "/images/logo.jpg",
  heroTeam: "/images/hero.jpg",
  officeCleaning: "/images/office-cleaning.png",
  constructionCleaning: "/images/construction-cleaning.png",
  commercialCleaning: "/images/commercial-cleaning.jpg",
  quoteContact: "/images/offertbild.png",
  shopCleaning: "/images/butiksstadning.jpg",
  workCabins: "/images/arbetsbod.png",
  floorCare: "/images/golvvard.png",
  windowCleaning: "/images/fonsterputs.jpg",
  stairCleaning: "/images/trappstadning.jpg",
  ecoFriendly: "/images/miljo.jpg",
  about: "/images/om-foretaget.jpg",
};

export const SERVICES = [
  {
    slug: "kontorsstadning",
    title: "Kontorsstädning",
    short: "Daglig eller schemalagd städning av kontor och kontorslandskap.",
    path: "/tjanster/kontorsstadning",
    image: ASSETS.officeCleaning,
  },
  {
    slug: "byggstadning",
    title: "Byggstädning",
    short: "Byggstädning efter renovering, ombyggnad och nyproduktion.",
    path: "/tjanster/byggstadning",
    image: ASSETS.constructionCleaning,
  },
  {
    slug: "butiksstadning",
    title: "Butiksstädning",
    short: "Ren och välkomnande butik anpassat efter öppettider.",
    path: "/tjanster/butiksstadning",
    image: ASSETS.shopCleaning,
  },
  {
    slug: "arbetsbodar",
    title: "Städning av arbetsbodar",
    short: "Daglig städning av etableringar och arbetsbodar.",
    path: "/tjanster/stadning-av-arbetsbodar",
    image: ASSETS.workCabins,
  },
  {
    slug: "golvvard",
    title: "Golvvård",
    short: "Skydda och förläng livslängden på era golv.",
    path: "/golvvard",
    image: ASSETS.floorCare,
  },
];

export const REVIEWS = [
  { text: "Trevlig personal och bra utfört arbete. Mycket nöjda!", author: "Kund i Bjuv" },
  { text: "Jättepositivt, bra service och trevligt bemötande.", author: "Kund i Helsingborg" },
  { text: "Bara positivt! Bra jobb och vänligt bemötande.", author: "Kund i Åstorp" },
];

export const FAQS = [
  {
    q: "Vilka områden arbetar ni i?",
    a: "Vi utför våra tjänster dagligen i hela nordvästra Skåne – från Bjuv, Helsingborg och Åstorp till Ängelholm, Höganäs, Klippan, Örkelljunga, Perstorp, Båstad, Svalöv och Landskrona.",
  },
  {
    q: "Kan ni anpassa städningen efter våra öppettider?",
    a: "Ja. Vi planerar uppdraget efter er verksamhet och kan städa dagligen, flera dagar i veckan, kvällar eller helger – under eller efter ordinarie öppettider.",
  },
  {
    q: "Vad ingår i städgarantin?",
    a: "Om något inte blev som överenskommet åtgärdar vi det utan extra kostnad. Vi följer upp våra uppdrag löpande för att säkerställa jämn kvalitet.",
  },
  {
    q: "Är personalen försäkrad och kontrollerad?",
    a: "All personal är kontrollerad i belastningsregistret, omfattas av sekretessavtal och har ID06-legitimation där det krävs. Vi har ansvarsförsäkring upp till 10 miljoner kronor.",
  },
  {
    q: "Hur får vi en offert?",
    a: "Fyll i offertformuläret eller ring 042-51077. Vi återkommer med en kostnadsfri offert anpassad efter er verksamhet och era ytor.",
  },
];

export const AREAS = [
  "Bjuv", "Helsingborg", "Åstorp", "Ängelholm", "Höganäs",
  "Klippan", "Landskrona", "Båstad", "Svalöv", "Perstorp", "Örkelljunga",
];

export const TRUST_POINTS = [
  { icon: "MapPin", title: "Lokal närvaro", text: "Förankrade i Bjuv och hela nordvästra Skåne." },
  { icon: "ShieldCheck", title: "Försäkrade", text: "Ansvarsförsäkring upp till 10 miljoner." },
  { icon: "Award", title: "ID06-legitimerade", text: "Legitimerad personal där arbetet kräver det." },
  { icon: "Leaf", title: "Miljö & hållbarhet", text: "Mer hållbara produktval i varje uppdrag." },
  { icon: "Heart", title: "Personlig service", text: "Samma kontakt genom hela uppdraget." },
];

export const COMPANY = {
  name: "Rena Tjänster",
  address: "Billesholmsvägen 4, 267 40 Bjuv",
  email: "info@renatjanster.se",
  phone: "042-51077",
  phoneLink: "tel:+4642510770",
  siteUrl: "https://renatjanster.se",
};
